import store from "../store";

export default function admin({ router }) {
  const userRole = store.getters["profile/profile"];
  if (userRole.scope !== 2) {
    return router.push({ name: "Default" });
  }
}
